import React from "react";
import foodOrderIcon from "../assets/images/Food_ordering.svg";
import foodipedia from "../assets/images/Foodipedia.svg";
import recepies from "../assets/images/Recipes.svg";
import FoodBookLogo from "../assets/images/bigFoodbookLogo.png";

import SettingsIcon from "@material-ui/icons/SettingsRounded";
import FavoriteIcon from "@material-ui/icons/FavoriteRounded";
import HistoryIcon from "@material-ui/icons/HistoryRounded";
import LocalOfferIcon from "@material-ui/icons/LocalOfferRounded";
import HeadsetMicIcon from "@material-ui/icons/HeadsetMicRounded";
import ModeCommentIcon from "@material-ui/icons/ModeCommentRounded";
import AccountCircleIcon from "@material-ui/icons/AccountCircleRounded";
import LockRoundedIcon from "@material-ui/icons/LockRounded";
import AboutUsIcon from "@material-ui/icons/Info";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import TNCIcon from "@material-ui/icons/Description";
import Typography from "@material-ui/core/Typography";
import { WELCOME_PAGE } from "./Colors";
import WalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { STORAGE_BASE_URL, DEFAULT_NOT_FOUND } from "./Urls";

export { FoodBookLogo };

// Common Constants
export const PREVENT_CACHE = "?ignoreCache=1";
export const FOODBOOK_TEXT = "FoodBook";
export const LIMIT_SIZE = "1100px";
export const APPBAR_HEIGHT = {
  desktop: "9vh",
  mobile: "70px"
};

export const THEME_COLORS = {
  ORANGE: "#E4993B",
  YELLOW: "#E5D721",
  GREY: "#333333",
  LIGHT_GREY: "#EAEAEA",
  BLACK: "#000000",
  WHITE: "#FFFFFF"
};

export const SHORT_MONTH = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

export const SESSION_TIMINGS = {
  Breakfast: "00:00-11:30",
  Lunch: "11:31-15:59",
  Snacks: "16:00-18:59",
  Dinner: "19:00-23:59"
};

export const SESSION_TIME_REVERSE_MAP = {
  "00:00-11:30": "Breakfast",
  "11:31-15:59": "Lunch",
  "16:00-18:59": "Snacks",
  "19:00-23:59": "Dinner"
};

export const ORDER_STATUS = {
  PAID: "orderpaid",
  PAY_PENDING: "orderpaypending",
  TIMEOUT: "autocancel_partialpaytimeout"
};

// Home Page Constants
export const SOCIAL_LINKS = [
  { label: "LinkedIn", link: "#" },
  { label: "Google+", link: "#" },
  { label: "Twitter", link: "#" },
  { label: "Facebook", link: "#" }
];

export const ABOUT_FOODBOOK_LINK = `${STORAGE_BASE_URL}/foodbook-allergents/about-foodbook.html`;

export const FOOTER_LINKS = [
  {
    label: "About " + FOODBOOK_TEXT,
    // url: `${STORAGE_BASE_URL}/foodbook-allergents/about-foodbook.html`,
    url: ABOUT_FOODBOOK_LINK,
    key: "aboutFoodbook"
  },
  {
    label: "Contact Us",
    url: `${STORAGE_BASE_URL}/foodbook-allergents/get-in-touch.html`,
    key: "contactUs"
  }
  // {
  //   label: "FAQs",
  //   url: `${STORAGE_BASE_URL}/foodbook-allergents/faqs.html`
  // },
  // {
  //   label: "Help & Support",
  //   url: `${STORAGE_BASE_URL}/foodbook-allergents/help-and-support.html`
  // }
];

export const BACKGROUND_LINKS = [
  { label: "About Us", link: "#" },
  { label: "Careers", link: "#" },
  { label: "In Media", link: "#" },
  { label: "Privacy Policy", link: "#" },
  { label: "Support", link: "#" }
];

export const COMPASS_DETAILS = {
  ADDRESS: [
    "Compass Group India Support Services Pvt Ltd,",
    "Ferns City, Doddanekkundi, Bengaluru,",
    "Karnataka 560037"
  ],
  CONTACT_NO: "+91000000000",
  WEB_ADDRESS: "www.compassgroup.com"
};

export const NAV_LINKS = [
  { label: "Home", url: "home" },
  { label: "About us", url: "aboutus" },
  { label: "Features", url: "features" },
  { label: "Testimonial", url: "testimonial" },
  { label: "Contact", url: "contactus" }
];

// Auth Page Constats

export const SLIDER_CONSTANTS = {
  SIGNUP: {
    title: "New Here ?",
    subheading: "Sign up and discover " + FOODBOOK_TEXT,
    buttonLabel: "SIGN UP",
    nextAction: "signup"
  },
  SIGNIN: {
    title: " One of us?",
    subheading: "Sign In, we've missed you!",
    buttonLabel: "SIGN IN",
    nextAction: "signin"
  },
  TOKEN_BASED_LOGIN: {
    title: "Verification Required !!!",
    subheading: "",
    buttonLabel: "",
    nextAction: ""
  }
};

export const TNC_STATEMENT = (
  <Typography
    variant="body2"
    style={{ color: WELCOME_PAGE.primaryColor, textDecoration: "underline" }}
  >
    {/* <a href="#" style={{ color: WELCOME_PAGE.primaryColor }} target="_blank">
      {" "}
      Terms and Conditions{" "}
    </a> */}
    Terms and Conditions
  </Typography>
);

export const PVC_STATEMENT = (
  <Typography
    variant="body2"
    style={{ color: WELCOME_PAGE.primaryColor, textDecoration: "underline" }}
  >
    {/* <a href="#" style={{ color: WELCOME_PAGE.primaryColor }} target="_blank">
      {" "}
      Terms and Conditions{" "}
    </a> */}
    Privacy Policy
  </Typography>
);

export const TNC_LINK =
  STORAGE_BASE_URL + "/foodbook-general/foodbook-tnc.html"; // terms and conditions link

export const PRIVACY_POLICY_LINK =
  "https://storage.googleapis.com/smartqdemo/foodbook/Compass%20Group%20Privacy%20Policy%20v1.0_FINAL.pdf";

export const DETAILS_FOR_IFRAME = {
  foodname: "Terms and Conditions",
  url: TNC_LINK
};

export const DETAILS_FOR_IFRAME_PVC = {
  foodname: "Privacy Policy",
  url: PRIVACY_POLICY_LINK
};

export const SIGN_IN_UP_TRANSITION_DURATION = 500;
export const HOMEPAGE_AUTH_TRANSITION_DURATION = 500;

// Landing Page Constants

export const CLEAR_CART_DIALOG = {
  title: "Clear Cart Items ?",
  message: "Selecting item from different cafeteria will clear cart items",
  itemMessage: "Selecting item from different cafeteria will clear cart items",
  positiveButtonLabel: "Proceed",
  negativeButtonLabel: "Cancel"
};

export const CLEAR_CART_FOR_PREBOOK = {
  title: "Clear Cart Items ?",
  message:
    "This action will clear the items in your cart. Do you wish to proceed?",
  itemMessage:
    "This action will clear the items in your cart. Do you wish to proceed?",
  positiveButtonLabel: "Proceed",
  negativeButtonLabel: "Cancel"
};

export const EXPLORE_FOODBOOK_OPTIONS = [
  {
    title: "Foodiepedia",
    content:
      "Interesting food facts, stories and some trivia. Foodipedia is all that and",
    image: foodipedia
  },
  {
    title: "Recipes",
    content: "Peek into our chefs' own recipe book and be a Masterchef too!",
    image: foodOrderIcon
  },
  {
    title: "Ordering Process",
    content: "Ordering food at your cafeteria is just a tap away",
    image: recepies
  }
];

export const RECIPES_URL = STORAGE_BASE_URL + "/foodbook_recipe/recipe";
export const FOODIPEDIA_URL =
  STORAGE_BASE_URL + "/foodbook_Foodiepedia/foodiepedia";
export const ORDERING_URL =
  STORAGE_BASE_URL + "/foodbook-ordering/food_ordering.html";

// Menu Listing Page Constants

export const SEARCH_NOT_FOUND_MESSAGE =
  "We couldn’t find any items matching your search. Please try a new keyword.";
export const NOT_FOUND_ITEMS = "No item available for selected date";
export const CART_DISABLED_MESSAGE = "Counter is offline at the moment";
export const PLACEHOLDER_FOOD_IMAGE =
  "https://storage.googleapis.com/smartqdemo/foodbook-general/filler.jpg";

//Settings Pages
export const GENERIC_ERROR_MESSAGE = "Something went wrong :(";

// Quick Tab options
export const QUICK_TAB_OPTIONS = [
  {
    label: FOODBOOK_TEXT + " Wallet",
    route: "foodbook_wallet",
    icon: WalletIcon
  },
  {
    label: "Favorites",
    route: "favorites",
    icon: FavoriteIcon
  },
  {
    label: "Order History",
    route: "order_history",
    icon: HistoryIcon
  },
  {
    label: "Profile",
    route: "profile",
    icon: AccountCircleIcon
  },
  {
    label: "Preferences",
    route: "preferences",
    icon: SettingsIcon
  },

  // {
  //   label: "Offers",
  //   route: "offers",
  //   icon: LocalOfferIcon
  // },
  // {
  //   label: "Feedback",
  //   route: "feedback",
  //   icon: ModeCommentIcon
  // },
  {
    label: "Support",
    route: "support",
    icon: HeadsetMicIcon
  },
  {
    label: "About Us",
    route: "about",
    icon: AboutUsIcon
  },
  {
    label: "Terms & Conditions",
    route: "tnc",
    icon: TNCIcon
  },
  {
    label: "Privacy Policy",
    route: "pvc",
    icon: LockRoundedIcon
  },
  {
    label: "Logout",
    route: "logout",
    icon: LogoutIcon
  }
];

export const FILTER_OPTIONS = [
  {
    label: "Veg",
    option: "V"
  },
  {
    label: "Egg",
    option: "E"
  },
  {
    label: "Non-Veg",
    option: "N"
  }
];

export const AFTER_FEEDBACK_MESSAGE = "Thank you for your feedback";
export const AFTER_REPORT_MESSAGE = "Issue raised to IT Helpdesk";

export const ORDER_SERVED_SUCCESS_MESSAGE = "Have a happy meal";
export const ORDER_SERVED_FAILED_MESSAGE =
  "Status update failed, please try again!";

// Wallet Page

export const FOODBOOK_WALLET_NAME = FOODBOOK_TEXT + " Wallet";

export const TRANSACTION_MESSAGE = {
  "auto deduct": "Paid for Order",
  "alternative order cashback": "Cashback Received",
  "auto refund order push failed": "Order Cancelled",
  "auto refund order failed": "Order Cancelled",
  "promo ecash": "Promotional Offer",
  "referral credit": "Referral Amount",
  counterloading: "Added to Account",
  "card recharge": "Wallet Recharge",
  "card reissue": "Card Reissues",
  "order refund": "Refunded"
};
export const RECHARGE_NOT_AVAILABLE_MSG =
  "Sorry online recharge is not enabled for your Foodcourt";

export const GENERAL_CONFIRMATION_MSG = "Are you sure you want to proceed ? ";
export const GENERAL_ERROR_MSG =
  "Oops! Something went wrong. Please try again.";
export const DIFF_CART_ITEMS_ALERT_MSG =
  "Cart already contains items from different restaurant...";
export const SODEXO_LINK_SUCESS_MSG =
  "Sodexo successfully linked. Fetching the balance.";
export const ORDER_TIMEOUT_MSG = "Connection timed out. Please try again.";

//Order History and Feedback Pages

export const NOTIFICATION_PERMISSION = {
  title: "Subscribe to Notification ?",
  description: "We would like to inform about order status...",
  positiveButtonLabel: "Proceed",
  negativeButtonLabel: "Not now"
};

export const INPROGRESSACTIONS = [
  { id: 0, label: "Order Placed Successfully", serverStatus: "orderpaid" },
  {
    id: 1,
    label: "Order Received by the Counter",
    serverStatus: "orderpushed"
  },
  { id: 2, label: "Counter is processing your order", serverStatus: "" },
  {
    id: 3,
    label: "Your order is ready to collect",
    serverStatus: "readysmssent"
  }
];

export const PREFERENCES_OPTIONS = {
  // "Food Type": [
  //   { label: "Habitual" },
  //   { label: "Explorer" },
  //   { label: "Health Conscious" },
  //   { label: "Traditional" }
  // ],
  // notification_enabled: {
  //   displayText: "Notification",
  //   options: [{ label: "OFF", extraLabel: "ON" }]
  // },
  sms_enabled: {
    displayText: "SMS",
    options: [{ label: "OFF", extraLabel: "ON" }]
  }
  // Cuisines: [
  //   { label: "Global" },
  //   { label: "North Indian" },
  //   { label: "South Indian" },
  //   { label: "All" }
  // ]
};
//Checkout Page
export const NOTE_TO_CHEF_PLACEHOLDER = "Any words to the chef?";
export const MULTI_REST_FEATURE_MSG =
  "Feature available for Multiple counters ordering, hence clearing cart...";
export const PASS_EXPIRY_MSG =
  "Sorry, your Cafe Pass is Expired. Please book again";
// Contact us
export const CONTACT_US_SUCCESS_MESSAGE =
  "Thanks for contacting us, we will get in touch soon.";
export const CONTACT_US_ERROR_MESSAGE =
  "Oops... Something went wrong! Please try again.";

export const CART_AUTO_CLEAR_MESSAGE = "Cart expired...";
export const FC_NOT_CONFIGURED =
  "Seems like Cafeteria is not fully configured. Please come back later.";

// export const TESTIMONIAL_DATA = [
//   {
//     description:
//       "Great Website for ordering and also got a lot of insights for maintaing my my food diet. Keep up the good work.",
//     role: "Operations Manager",
//     name: "Mahesh C",
//     image: sampleAvatar
//   },
//   {
//     description:
//       "Great Website for ordering and also got a lot of insights for maintaing my my food diet. Keep up the good work.",
//     role: "Operations Manager",
//     name: "Mahesh C",
//     image: sampleAvatar
//   },
//   {
//     description:
//       "Great Website for ordering and also got a lot of insights for maintaing my my food diet. Keep up the good work.",
//     role: "Operations Manager",
//     name: "Mahesh C",
//     image: sampleAvatar
//   },
//   {
//     description:
//       "Great Website for ordering and also got a lot of insights for maintaing my my food diet. Keep up the good work.",
//     role: "Operations Manager",
//     name: "Mahesh C",
//     image: sampleAvatar
//   }
// ];

export const ACTIONS_TO_CONSIDER = [
  "rejected",
  "rejectsmssent",
  "rejecteddone",
  "autocancel",
  "autocancelsmssent",
  "autocanceldone",
  "autocancel_partialpaytimeout",
  "served",
  "ordercancelled",
  "ordercancelledsmssent",
  "ordercancelleddone"
];

export const APP_ID = "foodbook-old";



// WEBPACK FOOTER //
// ./src/utils/Constants.js